import { useState } from 'react';
import { shallowEqual } from 'react-redux';

import { Alert, Spacer } from '@zillow/constellation';
import { TextButton } from '@zillow/constellation-10';

import { useSelector } from '../../../selectors/useSelector';

import ArchivePropertyModal from '../../../components/Modal/ArchivePropertyModal';

const ArchivedBanner = () => {
  const {
    isArchived,
    isConversionRequired,
    isSelfServeOnboardingInProgress,
    listingAlias,
    street,
    city,
    state,
    zip,
    unit,
  } = useSelector(
    (state) => ({
      isArchived: state.properties.currentProperty.isArchived,
      isConversionRequired: state.properties.currentProperty.multiToSingleFamilyConversion.isConversionRequired,
      listingAlias: state.properties.currentProperty.listingAlias,
      street: state.properties.currentProperty.street,
      city: state.properties.currentProperty.city,
      state: state.properties.currentProperty.state,
      zip: state.properties.currentProperty.zip,
      unit: state.properties.currentProperty.unit,
      isSelfServeOnboardingInProgress:
        state.properties.currentProperty.selfServeOnboardingStatus.isSelfServeOnboardingInProgress,
    }),
    shallowEqual,
  );

  const [displayArchivePropertyModal, setDisplayArchivePropertyModal] = useState(false);

  return (
    <>
      {isArchived && (!isConversionRequired || isSelfServeOnboardingInProgress) && (
        <Spacer marginBottom="md">
          <Alert
            actionButton={<TextButton onClick={() => setDisplayArchivePropertyModal(true)}>Unarchive</TextButton>}
            body="This property is archived. Unarchive it to make edits."
          />
        </Spacer>
      )}
      {displayArchivePropertyModal && (
        <ArchivePropertyModal
          onClose={() => setDisplayArchivePropertyModal(false)}
          isArchived={isArchived}
          listingAlias={listingAlias}
          address={{ street, city, state, zip, unit }}
        />
      )}
    </>
  );
};

export default ArchivedBanner;
